export default function($) {
	$('form.js-add-to-cart-input').on( 'click', '.js-add-to-cart-button-plus, .js-add-to-cart-button-minus', function() {
		// Get current quantity values
		var qty = $( this ).closest( 'form.js-add-to-cart-input' ).find( '.js-add-to-cart-qty' );
		var val = parseFloat(qty.val());
		var max = parseFloat(qty.attr( 'max' ));
		var min = parseFloat(qty.attr( 'min' ));
		var step = parseFloat(qty.attr( 'step' ));
		var add_to_cart_link = $(this).parent().parent().siblings('.o-layout__item').find('.js-add-to-cart-button').attr('href');

		// Change the value if plus or minus
		if ( $( this ).is( '.js-add-to-cart-button-plus' ) ) {
			var old_quantity = add_to_cart_link.substring(add_to_cart_link.lastIndexOf('=') + 1);
			if ( max && ( max <= val ) ) {
				qty.val( max );
				qty.attr('value', max);
				var add_to_cart_link = add_to_cart_link.replace('quantity='+old_quantity, 'quantity='+max);
			} else {
				qty.val( val + step );
				qty.attr('value', val + step);
				var add_to_cart_link = add_to_cart_link.replace('quantity='+old_quantity, 'quantity='+(val + step));
			}
			$(this).parent().parent().siblings('.o-layout__item').find('.js-add-to-cart-button').attr('href', add_to_cart_link);
		} else {
			var old_quantity = add_to_cart_link.substring(add_to_cart_link.lastIndexOf('=') + 1);
			if ( min && ( min >= val ) ) {
				qty.val( min );
				qty.attr('value', min );
				var add_to_cart_link = add_to_cart_link.replace('quantity='+old_quantity, 'quantity='+min);
			} else if ( val > 1 ) {
				qty.val( val - step );
				qty.attr('value', val - step );
				var add_to_cart_link = add_to_cart_link.replace('quantity='+old_quantity, 'quantity='+(val - step));
			}
			$(this).parent().parent().siblings('.o-layout__item').find('.js-add-to-cart-button').attr('href', add_to_cart_link);
		}

	});

	$( '.js-add-to-cart-qty' ).on('change keyup mouseup', function() {
		var add_to_cart_link = $(this).parent().parent().siblings('.o-layout__item').find('.js-add-to-cart-button').attr('href');
		var old_quantity = add_to_cart_link.substring(add_to_cart_link.lastIndexOf('=') + 1);
		var add_to_cart_link = add_to_cart_link.replace('quantity='+old_quantity, 'quantity='+$(this).val());

		$(this).parent().parent().siblings('.o-layout__item').find('.js-add-to-cart-button').attr('href', add_to_cart_link);
	});

	var bottom_bundled_products = $( '.js-bundle-product-no-cart' )
  if ( bottom_bundled_products.length > 0 ) {
    bottom_bundled_products.find( 'select' ).remove()
  }

}
